<template>
    <form class="nav-bar-form form-horizontal"  @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['bg_color']}">
            <label for="bg_color" class="col-sm-2 control-label">Color de Fondo</label>
            <div class="col-sm-10">
                <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" v-model="data.bg_color"  ></div>
                <div class="col-sm-1 column-color"><el-color-picker v-model="data.bg_color"  ></el-color-picker></div>
                <a class="col-sm-7 control-label" style="text-align:left;"  @click="data.bg_color = '#09132E'">Valor por defecto</a>
                <div class="help-block" v-for="e in errors['bg_color']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['font_color']}">
            <label for="" class="col-sm-2 control-label">Color de Fuente</label>
            <div class="col-sm-10">
                <div class="col-sm-4 column-color"><input type="text" class="form-control color-control" v-model="data.font_color" ></div>
                <div class="col-sm-1 column-color"><el-color-picker v-model="data.font_color"></el-color-picker></div>
                <a class="col-sm-7 control-label" style="text-align:left;" @click="data.font_color='#FFFFFF'">Valor por defecto</a>
                    <div class="help-block" v-for="e in errors['font_color']">{{e}}</div>
            </div>
        </div>
        <div  class="form-group" >
            <label for="" class="col-sm-2 control-label">Logo Micha</label>
            <div class="col-sm-10">
                <el-select v-model="logo_id" placeholder="Seleccione Logo"  id="logo">
                    <el-option
                        v-for="item in navbar.logos"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>

        <div class="form-group">
            <label for class="col-sm-2 control-label">Agregar Nuevo Menú</label>
            <div class="col-sm-10">
                <a  v-bind:href="'backend/mantenedor-navbar/menu/'+navbar.id" >
                    <i class="material-icons">add_circle</i>
                </a>
                <br />
            </div>
        </div>
        <div class="form-group">
            <label for="" class="col-sm-2 control-label">Menus  ss</label>
            <div class="col-sm-10">
                <div class="panel panel-default">
                     <div class="panel-body">
                        <table class="table"  width="90%">
                            <thead>
                                <tr>
                                    <th>Orden</th>
                                    <th>Nombre</th>
                                    <th>Uso Login</th>
                                    <th>Activo</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(m,index) in data.menus">
                                    <td style="text-align:center;">
                                            <a href="#"  @click.prevent="up(index)"><i class="material-icons">arrow_upward</i></a>
                                            <a href="#"  @click.prevent="down(index)"><i class="material-icons">arrow_downward</i></a>
                                    </td>
                                    <td>{{m.name}}</td>
                                    <td>{{m.is_login ? 'Si':'No'}}</td>
                                    <td>{{m.active ?'Si':'No' }}</td>
                                    <td>
                                        <a :href="'/backend/mantenedor-navbar/' + m.id +'/editMenu'"  data-toggle="tooltip" title="Editar">
                                            <i class="material-icons">create</i>
                                        </a>
                                         <a href="#" v-if="!m.is_login"  @click.prevent="deleteMenu(index)"><i class="material-icons">remove_circle</i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                     </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="" class="col-sm-2 control-label">Activo</label>
            <div class="col-sm-10">
                <el-switch v-model="data.active" on-text="SI" off-text="NO" >
                </el-switch>
            </div>
        </div>
        <!-- <div class="form-group">
            <label for="" class="col-sm-2 control-label">Previsualización</label>
            <div class="col-sm-10">
                <nav class="menu-cha"  :style="'background-color: ' + data.bg_color + '!important'" style="height: 90px;">  
                    <div >
                        <section class="cont-logo">                            
                            <img :src="src" height="50" alt="">    
                        </section>
                        <section class="cont-menu">
                            <table>
                                <tr>
                                    <td v-for="menu in data.menus" v-if="menu.active && menu.item_icon_route ==''">
                                        <div class="dropdown">
                                            <button type="button"  data-toggle="dropdown" class="dropdown-toggle " :style="!menu.is_login?'color:' + data.font_color :''" :class="menu.is_login ?'btn btn-primary btn-ingresar':'btn-menu '">
                                                {{menu.show_type_button_id != 3 ? menu.text_button :''}}
                                                <div v-if="menu.show_type_button_id != 2 && !menu.is_login" class="menu-icon">
                                                    <span :style="'background-color:' +  data.font_color "></span> 
                                                    <span :style="'background-color:' +  data.font_color "></span> 
                                                    <span :style="'background-color:' +  data.font_color "></span>
                                                </div>
                                                <span v-else-if="!menu.is_login" class="caret" ></span>
                                            </button>
                                             <ul class="dropdown-menu " :class="menu.is_login?'menu-usuario':'menu-contacto'"> 
                                                <li class="cerrar-menu">
                                                <a   class="btn-cerrar">Cerrar <span class="close">×</span></a>
                                                </li>
                                                <li class="barra"></li>              
                                                <li v-for="item in menu.items" v-if="item.active">
                                                    <a v-if="!item.children">
                                                         <img v-if="item.use_icon && !item.use_material_icons" :src="item.icon" :alt="item.tooltip" />
                                                        <i v-if="item.use_icon && item.use_material_icons" class="material-icons">{{item.icon}}</i>    
                                                        {{item.name}}
                                                    </a>
                                                    <a v-else :href="'#SubMenu' + item.id" class="list-group-item" data-toggle="collapse">
                                                        <img v-if="item.use_icon && !item.use_material_icons" :src="item.icon" :alt="item.tooltip" />
                                                        <i v-if="item.use_icon && item.use_material_icons" class="material-icons">{{item.icon}}</i>
                                                        {{item.name}}<span class="caret"></span>
                                                    </a>
                                                    <div v-if="item.children" class="collapse in list-group-submenu" :id="'SubMenu' + item.id ">
                                                         <a v-for="subitem in item.children"  v-if="subitem.active"   class="list-group-item">
                                                            {{subitem.name}} 
                                                        </a>
                                                    </div>
                                                </li>
                                             </ul>
                                        </div>
                                    </td>                                    
                                 </tr>
                            </table>
                        </section>
                    </div>
                </nav>
            </div>
        </div> -->
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
               <a class="btn btn-default" href="backend">Cancelar</a>
                 <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>    
    .el-upload{
        display: block !important;
    }
    .color-control {
        width: 200px;
    }
    .column-color {
        padding-left:0px;padding-right:0px;
    }
    .design {
        background: #F7F7F7;
        border: 1px solid #F7F7F7;
        border-radius: 4px;
        display: block;
        padding-top: 14px;
        margin-bottom: 7px;
    }
    .subtitle {
        color: #757575;
    }
    .cont-logo{
        margin: 10px 10px 10px 10px;
        padding-bottom: 10px;
    }

    .menu-cha .menu-icon span {
        margin-top: 5px!important;
    }
 
</style>
<script>
import ElementUI from 'element-ui';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import ElColorPicker from 'element-ui/lib/color-picker';
import { Message } from 'element-ui';

export default {
    
    data:function(){
        const navbar = _.cloneDeep(this.navbar);

        navbar.menus = _.values(navbar.menus);


        var logo = Object.values(navbar.logos).find(e=> e.id === navbar.logo_id);
          
        return{
            data:navbar,
            logo_id: logo.id,
            src:logo.src,
            errors:{}
        }

    },  
    watch:{
        logo_id: function(logo_id){
            var logo = Object.values(this.navbar.logos).find(e=> e.id === logo_id);
            this.data.logo_id = logo_id;
            this.src = logo.src;
        }
    },
    props:['user','navbar'],
    components:{
        ElSelect,
        ElOption
    },
    methods:{
        
        validated:function(){
            this.errors={};

            if(this.bg_color ==='' || this.bg_color  === null )
                this.errors['bg_color'] = ['Debe seleccionar un color de fondo'];
            
            if(this.font_color === '' || this.font_color === null)
                this.errors['font_color'] =['Debe seleccionar un color de fuente'];

            if(_.values(this.errors).length > 0 )
                return false;
            else
                return true;
        },
        submit: function(){
            var selft = this;
             
            if(this.validated()){

                // this.data.menus.forEach(e => e.items=[]);
                                
                axios({
                    url: 'backend/mantenedor-navbar/update',
                    method: "PUT" ,
                    data:this.data
                })
                .then(response => {
                    window.location.replace(response.data.redirect);
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
                
            }else{
                this.$message.error('Revise los errores en el formulario antes de continuar.');    
            }
           
        },
        up: function(from){
            if(from == 0)
                return;

            var to = from - 1;
            var pos = 1 ;

            this.data.menus.splice(to, 0, this.data.menus.splice(from, 1)[0]);

            this.data.menus.forEach(c => {
                c.order = pos;
                pos++;
            });

        },
        down: function(from){
            var to = from + 1;
            var pos = 1 ;
            this.data.menus.splice(to, 0, this.data.menus.splice(from, 1)[0]);
            this.data.menus.forEach(c => {
                c.order = pos;
                pos++;
            });
        },
        deleteMenu:function(index){
            this.data.menus.splice(index,1);
            
        }
    }
}
</script>